import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../Components/Auth";
import {
  TextField,
  Box,
  Stack,
  InputAdornment,
  IconButton,
  Link,
} from "@mui/material";
import LoginIcon from "@mui/icons-material/Login";
import PersonIcon from "@mui/icons-material/Person";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import KeyIcon from "@mui/icons-material/Key";
import Buttons from "../../Components/Button/Buttons";
import { loginApi } from "../../../serviceFile/ApiService";
import Toaster from "../../Components/Toaster";

const Login = () => {
  const [vendorCodeErr, setVendorCodeErr] = useState(""); // state used to maintain errors
  const [vendorCode, setVendorCode] = useState(""); // state used for store vendor code
  const [passwordErr, setPasswordErr] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const auth = useAuth();

  // Function to handle password display
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  // useEffect hook to check if the user is already authenticated (logged in) and redirect them to the appropriate page accordingly
  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      navigate("/Dashboard/PurchaseDetails", { replace: true });
    }
    if (!token) {
      navigate("/", { replace: true });
    }
  }, [auth, navigate]);

  // vendor code submission function
  const handleSubmit = () => {
    console.log("heeeeeee");
    let flag = 0;
    if (vendorCode.trim().length === 0) {
      setVendorCodeErr("Vendor code is required");
      flag = 1;
    }
    if (password.trim().length === 0) {
      setPasswordErr("Password is required");
      flag = 1;
    }
    if (vendorCodeErr !== "" || passwordErr !== "") {
      return;
    }
    if (flag === 0) {
      const body = {
        vendor_code: vendorCode,
        password: password,
      };

      loginApi(body)
        .then((res) => {
          const errorMessage = res?.data?.message;
          if (res?.data?.status === 404) {
            Toaster(errorMessage, 134, ["error"]);
          } else {
            localStorage.setItem("accessToken", res?.data?.access);
            localStorage.setItem("refreshToken", res?.data?.refresh);
            localStorage.setItem("vendor_code", vendorCode);
            auth.login();
            navigate("/Dashboard/PurchaseDetails", { replace: true });
          }
        })
        .catch((err) => {
          const value = err?.response?.data?.detail;
          if (value === "No active account found with the given credentials") {
            Toaster(
              "You have entered an invalid vendor code or password",
              982,
              ["error"]
            );
          } else {
            Toaster("Sorry,something went wrong!", 98, ["error"]);
          }
        });
    }
  };

  // function to handle vendor code validations
  const handleVendorCode = (e) => {
    const vendorCd = e?.target?.value;
    let vendorCodeCheck = new RegExp(/^\d+(?: \s\d+)*$/).test(vendorCd);
    setVendorCode(vendorCd);
    if (vendorCd === null || vendorCd === "")
      setVendorCodeErr("Vendor code is required");
    else if (vendorCd.trim().length === 0) {
      setVendorCodeErr("Vendor code is required");
    } else if (!vendorCodeCheck) {
      setVendorCodeErr("Please enter valid vendor code");
    } else {
      setVendorCodeErr("");
      setVendorCode(vendorCd);
    }
  };

  // function to handle password
  const handlePassword = (e) => {
    const passwordValue = e?.target?.value;
    const regex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9\s]).{8,}$/;

    setPassword(passwordValue);
    if (passwordValue === null || passwordValue === "")
      setPasswordErr("Password is required");
    else if (passwordValue.trim().length === 0) {
      setPasswordErr("Password is required");
    } else if (!regex.test(passwordValue)) {
      setPasswordErr("Please enter a valid password");
    } else {
      setPasswordErr("");
      setPassword(passwordValue);
    }
  };

  // function to handle forget password
  const handleForgetPassword = () => {
    navigate("/Registration/ForgetPassword", { replace: true });
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "start",
        alignItems: "center",
      }}
    >
      <Stack spacing={3} direction="row" width="100%">
        <Stack
          direction="column"
          spacing={2}
          sx={{ marginTop: "30px !important", width: "50%" }}
        >
          <TextField
            id="outlined-basic"
            label="Vendor code"
            variant="outlined"
            autoComplete="off"
            type="text"
            size="medium"
            margin="dense"
            sx={{ width: { xs: "250px", sm: "300px" } }}
            error={!!vendorCodeErr}
            helperText={vendorCodeErr}
            InputProps={{
              shrink: true,
              startAdornment: (
                <InputAdornment position="start">
                  <PersonIcon style={{ color: "rgb(64, 132, 255) " }} />
                </InputAdornment>
              ),
            }}
            onChange={(e) => handleVendorCode(e)}
          />
          <TextField
            id="outlined-password-input"
            label="Password"
            variant="outlined"
            type={showPassword ? "text" : "password"}
            autoComplete="current-password"
            onChange={handlePassword}
            sx={{ width: { xs: "250px", sm: "300px" } }}
            error={!!passwordErr}
            helperText={passwordErr}
            InputProps={{
              shrink: true,
              startAdornment: (
                <InputAdornment position="start">
                  <KeyIcon style={{ color: "rgb(242, 200, 35) " }} />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    // onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? (
                      <VisibilityOff style={{ color: "rgb(0,0,139)" }} />
                    ) : (
                      <Visibility style={{ color: "rgb(64, 132, 255) " }} />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <Link
            sx={{
              width: {
                xs: "250px",
                sm: "300px",
                justifyContent: "end",
                display: "flex",
              },
              cursor: "pointer ",
            }}
            variant="body2"
            onClick={handleForgetPassword}
          >
            Forgot password
          </Link>
          <Buttons
            onClick={handleSubmit}
            endIcon={<LoginIcon />}
            sx={{ width: { xs: "250px", sm: "300px", marginTop: "-20px" } }}
            text="Sign in"
          />
        </Stack>
        <Stack
          sx={{
            width: "50%",
            display: { xs: "none", sm: "block" },
          }}
        >
          <img
            src="/assets/images/login-image.png"
            alt="LoginImage"
            style={{
              width: "350px",
              height: "350px",
              marginTop: "-30px",
              marginLeft: "20px",
            }}
          ></img>
        </Stack>
      </Stack>
    </Box>
  );
};

export default Login;
